import { GraphQLError } from 'graphql';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Queries = any;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Values = any[][];

export type ServerError = GraphQLError & {
  details: Record<string, string>;
};

export enum ColumnFormat {
  NUMBER = 'number',
  STRING = 'string',
  BOOLEAN = 'boolean',
  TIMESTAMP = 'timestamp',
}
